export const IMAGE_ORDERING_KEYS_ORDER_CONTROL = {
  KEY: 'IMAGE_ORDER',
  MAX_FILE_SIZE_MB: 'MAX_FILE_SIZE_MB',
  ALLOWED_FILE_TYPES: 'ALLOWED_FILE_TYPES',
};
